// Import des dépendances
import $ from 'jquery';
import initSwiper from '../utils/swiper';
import flatpickr from 'flatpickr';
import dayjs from 'dayjs';
import Swiper, {Navigation, Pagination} from 'swiper';
import mobile from '../utils/mobile';
import Plyr from 'plyr';
import categories from '../utils/categories';
import search from '../utils/search';

// Filtre en direct la grille de resultats deja affichee sur le nom du tour
// (champ "Search a tour", cf. FILTERS/filters_left.php) - fonction hors de
// l'objet `results` (pas de `this`) pour rester appelable telle quelle depuis
// setupLoadMore() une fois de nouvelles cartes ajoutees en AJAX.
function applyProductSearchFilter() {
	const $input = $("#__results_search_input");
	if (!$input.length) {
		return;
	}
	const query = search.stripDiacritics($input.val().trim().toLowerCase());
	let visibleResults = 0;
	$(".__results_products > ._wrap_produit").each(function () {
		const title = search.stripDiacritics($(this).find("h4").first().text().trim().toLowerCase());
		const matches = !query || title.indexOf(query) !== -1;
		$(this).toggle(matches);
		if (matches) visibleResults++;
	});

	const noSearchResult = query.length > 0 && visibleResults === 0;
	const $emptyState = $(".__results_empty_state");
	$emptyState.toggleClass("_is_visible", $emptyState.hasClass("_server_empty") || noSearchResult);
	$(".__clear_product_search").toggle(query.length > 0);
	$(".__load_more").toggleClass("_search_hidden", noSearchResult);
}

export const results = {
	search: false, init() {
		this.setupSwiper();
		this.setupSorting();
		this.setupFilters();
		this.setupPriceSlider();
		this.setupLoadMore();
		this.setupProductSearch();
		this.stickyMobileFilterBar();
		this.stickyDesktopFilterBar();
		this.checkSearchContainer();
		this.setupNumericFlexboxSorting();
		this.filterSwipe();
		this.bestExperiences();
		this.destinationReviews();
		this.setupVideoPlayer();
		mobile.init();
		if (mobile.state !== true) {
			this.setupCalendar();
		}
		this.setupActiveFilterChips();
		this.setupResultsCityFilter();
	},

	// Filtre ville rapide des pages categorie (cf. FILTERS/filters_left.php) :
	// le declencheur a besoin de la classe "_drop_result" pour que le menu
	// s'ouvre correctement (sans elle, drop.cleanResult() reinitialise
	// drop._id AVANT que drop.js ajoute la classe "_show" sur le bon
	// panneau - bug constate en testant sans cette classe). Mais
	// "_drop_result" fait aussi reecrire en direct le champ affiche a chaque
	// case cochee (cf. drop.putResult()), ce qui est trompeur : rien n'est
	// vraiment applique tant que "Apply" n'est pas clique, cf. retours
	// utilisateur. On memorise donc la valeur d'origine (rendue cote
	// serveur) et on la reimpose apres coup (le setTimeout(…, 0) laisse le
	// handler "change" de drop.js s'executer en premier) : le champ reste
	// visuellement fige jusqu'au rechargement de page qui suit "Apply".
	setupResultsCityFilter() {
		const $input = $(".__open_city_filter .__results_city_input");
		if (!$input.length) {
			return;
		}
		const originalValue = $input.val();

		$(document)
			.off("change.resultsCityFilterFreeze", '._menu_dropdown[data-drop="results_destination"] .__ul_checkbox input[type=checkbox]')
			.on("change.resultsCityFilterFreeze", '._menu_dropdown[data-drop="results_destination"] .__ul_checkbox input[type=checkbox]', () => {
				setTimeout(() => $input.val(originalValue), 0);
			});
	},

	setupActiveFilterChips() {
		const $modal = $(".__modal_filters");
		if (!$modal.length) return;

		$(document)
			.off("change.activeFilterChips", ".__modal_filters input[type=checkbox]")
			.on("change.activeFilterChips", ".__modal_filters input[type=checkbox]", () => {
				this.refreshActiveFilterChips();
			});

		$(document)
			.off("click.activeFilterChips", ".__active_filter_chip")
			.on("click.activeFilterChips", ".__active_filter_chip", (event) => {
				const $chip = $(event.currentTarget);
				if ($chip.data("filter-type") === "price-exact") {
					$(document).trigger("price:reset");
					this.refreshActiveFilterChips();
					return;
				}
				if ($chip.hasClass("__active_filter_chip_date")) {
					const dateInput = document.getElementById("result_date");
					if (dateInput && dateInput._flatpickr) dateInput._flatpickr.clear();

					const $form = $chip.closest("form");
					$form.find('input[name="filter_date_deb"], input[name="filter_date_end"]').val("");
					$form.find(".__date_chip_submit_proxy").remove();
					$form.append('<input type="hidden" class="__date_chip_submit_proxy" name="_btn" value="_new_search">');
					$form.get(0).submit();
					return;
				}
				const inputId = $chip.data("input-id");

				const $input = inputId ? $modal.find(`#${CSS.escape(String(inputId))}`) : $();
				if ($input.length && $input.is(":checked")) {
					$input.trigger("click");
				}
			});

		this.refreshActiveFilterChips();
	},

	refreshActiveFilterChips() {
		const $modal = $(".__modal_filters");
		const $container = $modal.find(".__active_filter_chips");
		if (!$container.length) return;

		const chips = [];
		$modal.find(".__contain_filters input[type=checkbox]:checked").each(function () {
			const $input = $(this);
			let label = $modal.find(`label[for="${this.id}"]`).text().trim();
			if (!label && $input.hasClass("__price_checkbox")) {
				const range = String($input.val()).split("_");
				label = range.length === 2 ? `€${range[0]} – €${range[1]}` : String($input.val());
			}
			if (label) chips.push({type: "checkbox", inputId: this.id, label});
		});
		const exactMin = String($modal.find(".__price_exact_min").val() || "");
		const exactMax = String($modal.find(".__price_exact_max").val() || "");
		if (exactMin || exactMax) {
			const label = exactMin && exactMax ? `€${exactMin} – €${exactMax}` : (exactMin ? `From €${exactMin}` : `Up to €${exactMax}`);
			chips.push({type: "price-exact", label});
		}

		$container.empty().toggleClass("_has_filters", chips.length > 0);
		chips.forEach((chip) => {
			const $button = $("<button>", {
				type: "button",
				class: "__active_filter_chip",
				"aria-label": `Remove filter ${chip.label}`,
			});
			$button.attr("data-filter-type", chip.type);
			if (chip.inputId) $button.attr("data-input-id", chip.inputId);
			$button.append($("<span>").text(chip.label));
			$button.append('<svg class="_ic_lucide" aria-hidden="true"><use xlink:href="#__ic_x_lucide"></use></svg>');
			$container.append($button);
		});
	},

	destinationReviews() {
		if (!document.querySelector('.__destination_reviews_swiper')) {
			return;
		}

		initSwiper('.__destination_reviews_swiper', {
			// 1.2 (etait 1) : laisse deviner le debut de la carte suivante
			// sur mobile, pour signaler que le bloc se swipe - cf. retours
			// utilisateur.
			slidesPerView: 1.2,
			spaceBetween: 18,
			watchOverflow: true,
			navigation: true,
			navigationEls: {
				nextEl: '.__destination_reviews_next',
				prevEl: '.__destination_reviews_prev',
			},
			breakpoints: {
				640: {slidesPerView: 1.5, spaceBetween: 20},
				900: {slidesPerView: 2.5, spaceBetween: 22},
				1280: {slidesPerView: 3.5, spaceBetween: 24},
			},
		});
	},

	// Video "Learn more about {destination/region/shore}" (destination_video /
	// region_video / shore_video en base) : le markup Plyr (.plyr__video-embed
	// + iframe YouTube, cf. results_bottom_destination|region|shore.php) et son
	// SCSS existaient deja, mais la librairie JS Plyr n'etait jamais chargee -
	// l'iframe brute s'affichait donc sans la vignette + bouton play habilles.
	setupVideoPlayer() {
		const el = document.querySelector('.plyr__video-embed');
		if (!el) {
			return;
		}

		const player = new Plyr(el, {
			youtube: {
				noCookie: false,
				rel: 0,
				showinfo: 0,
				iv_load_policy: 3,
				modestbranding: 1
			}
		});

		const setFilledPlayIcon = () => {
			document.querySelectorAll('.plyr__control--overlaid svg').forEach((svg) => {
				if (svg.dataset.filled) {
					return;
				}
				svg.setAttribute('viewBox', '-468 273 11 12');
				svg.removeAttribute('stroke');
				svg.removeAttribute('stroke-width');
				svg.removeAttribute('stroke-linecap');
				svg.removeAttribute('stroke-linejoin');
				svg.setAttribute('fill', 'currentColor');
				svg.innerHTML = '<use xlink:href="#__ic_play"></use>';
				svg.dataset.filled = 'true';
			});
		};

		player.on('ready', setFilledPlayIcon);
		window.requestAnimationFrame(setFilledPlayIcon);

		// Plyr (surtout en embed YouTube) peut (re)construire son bouton
		// overlay de facon asynchrone une fois l'API YouTube prete, parfois
		// apres l'evenement "ready" ou le rAF ci-dessus - l'icone restait
		// alors l'icone Plyr par defaut (triangle non colore, invisible sur
		// le fond violet fonce du bouton), cf. retours utilisateur. Un
		// observer sur le conteneur couvre ce cas sans dependre du timing
		// exact de Plyr.
		const observer = new MutationObserver(setFilledPlayIcon);
		observer.observe(el, {childList: true, subtree: true});
	},

	bestExperiences() {
		const updateExperienceIndicator = (nav) => {
			if (!nav) {
				return;
			}

			const active = nav.querySelector('.__experience_tab._activ');

			if (!active) {
				return;
			}

			const navRect = nav.getBoundingClientRect();
			const activeRect = active.getBoundingClientRect();
			nav.style.setProperty('--experience-indicator-left', `${activeRect.left - navRect.left + nav.scrollLeft}px`);
			nav.style.setProperty('--experience-indicator-width', `${activeRect.width}px`);
		};

		document.querySelectorAll('.__best_products .__experience_nav').forEach((nav) => {
			updateExperienceIndicator(nav);
			nav.addEventListener('scroll', () => updateExperienceIndicator(nav), {passive: true});
		});

		window.addEventListener('resize', () => {
			document.querySelectorAll('.__best_products .__experience_nav').forEach(updateExperienceIndicator);
		});

		$(document).on("click", ".__best_products .__experience_tab", function () {
			const _cat = String($(this).data("cat"));
			const $section = $(this).closest(".__best_products");
			const nav = $(this).closest('.__experience_nav').get(0);

			$(this).addClass("_activ");
			$section.find(".__experience_tab").not(this).removeClass("_activ").attr("aria-selected", "false");
			$(this).attr("aria-selected", "true");
			$section.find(".__cat_products").removeClass("_activ");
			$section.find(".__cat_products").filter(function () {
				return String($(this).data("cat")) === _cat;
			}).addClass("_activ");
			updateExperienceIndicator(nav);
		});
	},
	filterSwipe() {

		document.addEventListener('click', (e) => {
			const btn = e.target.closest('._activ_filters .__remove_btn');
			if (!btn) return;

			// Si l'utilisateur est en train de swiper, on ignore le click
			const swiperEl = btn.closest('._activ_filters');
			if (swiperEl && swiperEl.swiper && swiperEl.swiper.allowClick === false) return;

			const form = btn.closest('form');
			if (!form) return;

			const val = btn.dataset.remove;
			if (!val) return;

			let input = form.querySelector('input[name="_remove_filter"]');
			if (!input) {
				input = document.createElement('input');
				input.type = 'hidden';
				input.name = '_remove_filter';
				form.appendChild(input);
			}

			input.value = val;
			form.submit();
		});


		const el = document.querySelector('._activ_filters');
		if (!el) return;

		if (el.swiper) el.swiper.destroy(true, true);

		new Swiper(el, {
			slidesPerView: 'auto',
			spaceBetween: 8,
			freeMode: true,
			grabCursor: true,
			watchOverflow: true,
			observer: true,
			observeParents: true,
			noSwiping: false,

			// utile quand il y a des boutons/inputs dedans
			touchStartPreventDefault: false,
		});

		// const swiper = new Swiper('._activ_filters',{
		// 	slidesPerView: 'auto',
		// 	spaceBetween: 8,
		// 	freeMode: true,              // confort pour “chips”
		// 	grabCursor: true,
		// 	watchOverflow: true,
		// 	observer: true,
		// 	observeParents: true,
		// });


		// initSwiper('._activ_filters', {
		// 	loop: true,
		// 	slidesPerView: 3.6,
		// 	spaceBetween: 5,
		// 	navigation: false,
		// 	autoplay: true,
		// 	//autoHeight: true,
		// 	watchOverflow: true
		// });
	},

	checkSearchContainer() {
		if ($(".__results_container").length > 0) {
			this.search = true;
		}
	},

	setupNumericFlexboxSorting() {
		(function ($) {
			"use strict";

			$.fn.numericFlexboxSorting = function (options) {
				const settings = $.extend({
					elToSort: "._wrap_produit"
				}, options);

				const $select = this;
				const ascOrder = (a, b) => a - b;
				const descOrder = (a, b) => b - a;

				$select.on("change", () => {
					const selectedOption = $select.find("option:selected").attr("data-sort");
					sortColumns(settings.elToSort, selectedOption);
				});

				function sortColumns(el, opt) {
					const attr = `data-${opt.split(":")[0]}`;
					const sortMethod = opt.includes("asc") ? ascOrder : descOrder;
					const sortedArray = $(el).map((i, el) => $(el).attr(attr)).get().sort(sortMethod);

					sortedArray.forEach(value => {
						$(el).filter(`[${attr}="${value}"]`).css("order", value);
					});
				}

				return $select;
			};
		})($);

		$(".\--sorting").numericFlexboxSorting();
	},


	setupSwiper() {
		// if($(".__owl_destinations").length > 0){
		// 	initSwiper('.__owl_destinations', {
		// 		slidesPerView: 1, spaceBetween: 20, navigation: {
		// 			nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev',
		// 		}, pagination: {
		// 			el: '.swiper-pagination', clickable: true,
		// 		}, breakpoints: {
		// 			600: {
		// 				slidesPerView: 2, spaceBetween: 20,
		// 			}, 992: {
		// 				slidesPerView: 3.3, spaceBetween: 20,
		// 			}, 1200: {
		// 				slidesPerView: 3.5, spaceBetween: 20,
		// 			}, 1450: {
		// 				slidesPerView: 5, spaceBetween: 20,
		// 			},
		// 		}, on: {
		// 			init() {
		// 				document.querySelector('.__owl_destinations').classList.remove('_hide');
		// 			}
		// 		}
		// 	});
		// }
	},

	setupSorting() {
		$(".\--sorting").on("change", function () {
			const selectedOption = $(this).find("option:selected").attr("data-sort");
			results.sortColumns("._wrap_produit", selectedOption);
		});
	},

	sortColumns(elToSort, opt) {
		const attr = `data-${opt.split(":")[0]}`;
		const sortMethod = opt.includes("asc") ? (a, b) => a - b : (a, b) => b - a;

		const sortedArray = $(elToSort).map((_, el) => $(el).attr(attr)).get().sort(sortMethod);

		sortedArray.forEach(value => {
			$(elToSort).filter(`[${attr}="${value}"]`).css("order", value);
		});
	},

	// Presentation "GetYourGuide" (cf. retours utilisateur) : uniquement 2
	// champs Min/Max en saisie directe, pas de slider. "minIdx"/"maxIdx"
	// (indices dans steps[], deja la logique du filtre prix - cf.
	// ".__price_checkbox" values "0_100", "100_200"...) remplacent les
	// inputs range comme source de verite, mais la logique elle-meme
	// (paliers, cases a cocher reellement soumises) reste inchangee.
	setupPriceSlider() {

		const $priceBlock = $(".__price_inputs");
		if (!$priceBlock.length) return;

		const $checkboxes = $(".__price_checkbox");
		const maxIndex = $checkboxes.length;
		const steps = [];
		$checkboxes.each(function () {
			const parts = String($(this).val()).split("_");
			steps.push(parseInt(parts[0], 10));
		});
		steps.push(parseInt(String($checkboxes.last().val()).split("_")[1], 10));

		const $fieldMin = $(".__price_input_min");
		const $fieldMax = $(".__price_input_max");
		const $exactMin = $(".__price_exact_min");
		const $exactMax = $(".__price_exact_max");
		let exactMode = $exactMin.val() !== "" || $exactMax.val() !== "";

		let minIdx = 0;
		let maxIdx = maxIndex;

		const formatValue = idx => idx >= maxIndex ? steps[maxIndex - 1] + "+" : String(steps[idx]);
		const formatLabel = idx => "€" + formatValue(idx);

		const updateVisual = () => {
			if (exactMode) {
				$fieldMin.val("€" + ($exactMin.val() !== "" ? $exactMin.val() : steps[0]));
				$fieldMax.val("€" + ($exactMax.val() !== "" ? $exactMax.val() : steps[maxIndex - 1] + "+"));
				$checkboxes.prop("checked", false);
				return;
			}
			$fieldMin.val(formatLabel(minIdx));
			$fieldMax.val(formatLabel(maxIdx));

			const fullRange = minIdx === 0 && maxIdx === maxIndex;
			$checkboxes.each(function (i) {
				$(this).prop("checked", !fullRange && i >= minIdx && i < maxIdx);
			});
		};

		// Saisie directe : convertit la valeur tapee vers l'index de palier
		// le plus proche (steps[]) - aucune nouvelle logique de prix, juste
		// un autre point d'entree vers le composant existant.
		const closestStepIndex = value => {
			let closest = 0;
			let closestDiff = Infinity;
			steps.forEach((s, i) => {
				const diff = Math.abs(s - value);
				if (diff < closestDiff) {
					closestDiff = diff;
					closest = i;
				}
			});
			return Math.min(closest, maxIndex);
		};

		const parseTypedValue = raw => {
			const num = parseInt(String(raw).replace(/[^\d]/g, ""), 10);
			return Number.isNaN(num) ? null : num;
		};

		const commitField = isMin => {
			const $field = isMin ? $fieldMin : $fieldMax;
			const value = parseTypedValue($field.val());
			if (value === null) {
				updateVisual();
				return;
			}
			exactMode = true;
			const $target = isMin ? $exactMin : $exactMax;
			const $other = isMin ? $exactMax : $exactMin;
			const otherValue = parseTypedValue($other.val());
			$target.val(otherValue === null ? value : (isMin ? Math.min(value, otherValue) : Math.max(value, otherValue)));
			updateVisual();
			this.refreshActiveFilterChips();
		};

		$fieldMin.on("blur", () => commitField(true));
		$fieldMax.on("blur", () => commitField(false));
		$fieldMin.on("keydown", e => {
			if (e.key !== "Enter") return;
			e.preventDefault();
			commitField(true);
			$fieldMin.trigger("blur");
		});
		$fieldMax.on("keydown", e => {
			if (e.key !== "Enter") return;
			e.preventDefault();
			commitField(false);
			$fieldMax.trigger("blur");
		});

		// init depuis l'etat des checkboxes (session / filtres actifs)
		const checkedIdx = [];
		$checkboxes.each(function (i) {
			if ($(this).is(":checked")) checkedIdx.push(i);
		});
		if (checkedIdx.length) {
			minIdx = Math.min(...checkedIdx);
			maxIdx = Math.max(...checkedIdx) + 1;
		}

		$checkboxes.on("change", function () {
			exactMode = false;
			$exactMin.val("");
			$exactMax.val("");
			const checked = [];
			$checkboxes.each(function (index) {
				if ($(this).is(":checked")) checked.push(index);
			});
			minIdx = checked.length ? Math.min(...checked) : 0;
			maxIdx = checked.length ? Math.max(...checked) + 1 : maxIndex;
			updateVisual();
		});

		// Reset filtres (cf. "._btn_reset_filters" plus bas) : pas d'inputs
		// range a reinitialiser, remet directement les indices a la plage
		// complete.
		$(document).on("price:reset", () => {
			exactMode = false;
			$exactMin.val("");
			$exactMax.val("");
			minIdx = 0;
			maxIdx = maxIndex;
			updateVisual();
		});

		updateVisual();
	},

	setupFilters() {

		// "Change city" (page destination uniquement, cf. modal_filters.php
		// ".__filter_cities_nav_list") - masque tant que le champ est vide,
		// n'apparait qu'a la frappe. Reutilise directement
		// search.array_destination (deja charge sitewide, cf.
		// utils/search.js loadDestinations()) et le HTML "item.label" deja
		// pret (image + ville + region) : meme rendu que le moteur de
		// recherche du site, pas de liste/logique dupliquee, cf. retours
		// utilisateur ("même modèle que moteur de recherche").
		$(document).on('input', '.__filter_city_search_input', function () {
			const query = search.stripDiacritics($(this).val().trim().toLowerCase());
			const currentId = String($(this).data('currentId') || '');
			const $list = $('.__filter_cities_nav_list');
			let citySource = search.array_destination;
			const inlineSource = $(this).attr('data-city-source');

			// Les destinations Shore utilisent leurs propres URL et leur propre
			// liste de ports, fournie par la vue. On ne les melange jamais avec
			// le moteur de destinations classique.
			if (inlineSource) {
				try {
					citySource = JSON.parse(inlineSource);
				} catch (error) {
					citySource = [];
				}
			}

			// Pas de reaction avant 2 caracteres (evite une liste bruyante des
			// la 1re lettre) et 4 resultats max (les plus pertinents suffisent,
			// pas la peine d'en afficher 10), cf. retours utilisateur.
			if (query.length < 2) {
				$list.empty().hide();
				return;
			}

			const matches = citySource.filter(item => {
				if ((!inlineSource && item.type !== 'VI') || String(item.id) === currentId) return false;
				const haystack = search.stripDiacritics([item.title || '', item.value || ''].join(' ').toLowerCase());
				return haystack.includes(query);
			}).slice(0, 4);

			if (!matches.length) {
				$list.html('<div class="_no_result">No cities found</div>').show();
				return;
			}

			// ".__filter_city_result" partage le rendu visuel de
			// "._search_dropdown_item" (cf. _ophorus_accueil_hero.scss) sans
			// porter cette classe elle-meme : elle est aussi liee a un
			// handler JS global (search.js) qui bloque la navigation du lien
			// pour piloter le module de recherche sitewide - pas ce qu'on
			// veut ici (on veut juste suivre le lien vers la destination).
			const html = matches.map(item => `<a href="${item.url}" data-title="${item.title || ''}" class="__filter_city_result">${item.label}</a>`).join('');
			$list.html(html).show();
		});

		// Une ville en attente remplace temporairement les filtres et leurs
		// actions generales par les deux actions propres au changement de ville.
		$(document).on('click', '.__filter_city_result', function (e) {
			e.preventDefault();

			$('.__filter_city_pending')
				.attr('data-url', $(this).attr('href'))
				.find('.__filter_pending_value').text($(this).data('title') || '');
			$('.__filter_city_pending').prop('hidden', false);

			$('.__filter_city_search_input').val('');
			$('.__filter_cities_nav_list').empty().hide();
			$('.__filter_city_search').hide();
			$('.__contain_filters .__filter_line').hide();
			$('.__modal_filters ._bottom_modal').prop('hidden', true);
		});

		// "Change city" rouvre juste la recherche pour choisir une autre
		// ville - la selection en attente (data-url) est CONSERVEE tant
		// qu'aucun nouveau resultat n'est clique (le clic sur un resultat
		// l'ecrase deja, cf. handler ci-dessus), donc "Show results" navigue
		// quand meme vers la ville precedemment choisie si l'utilisateur ne
		// va pas au bout de son changement. Les autres filtres restent
		// masques : on est toujours en train de changer de ville, pas
		// revenu a l'etat normal, cf. retours utilisateur.
    $(document).on('click', '.__filter_pending_change', function () {
        const url = $('.__filter_city_pending').attr('data-url');

        if (url) {
            window.location.assign(url);
        }
    });

		// "Clear" annule entierement la selection en attente et revient a
		// l'etat normal (ville actuelle + tous les filtres), sans toucher
		// aux autres filtres actifs, cf. retours utilisateur.
		$(document).on('click', '.__filter_pending_clear', function () {
			$('.__filter_city_pending').prop('hidden', true).removeAttr('data-url');
			$('.__filter_city_search').show();
			$('.__contain_filters .__filter_line').show();
			$('.__modal_filters ._bottom_modal').prop('hidden', false);
		});

		// Une ville en attente est une navigation, pas un filtre a soumettre
		// avec le reste du formulaire - "Show results" redirige directement
		// vers cette ville au lieu de lancer la recherche filtree normale.
		$(document).on('submit', '.__modal_filters form', function (e) {
			const $requiredCities = $(this).find('.--filter_destination[data-require-one="true"]');
			if ($requiredCities.length && !$requiredCities.is(":checked")) {
				$requiredCities.first().prop("checked", true);
			}
			const url = $('.__filter_city_pending').attr('data-url');
			if (url) {
				e.preventDefault();
				window.location.href = url;
			}
		});

		// $(document).on('click', '.__open_dates', function (e) {
		// 	e.preventDefault();
		// 	e.stopPropagation();
		//
		// 	const $root = $(this).parent();
		// 	const $inlineBox = $root.find('._calendar_inline').first();
		//
		// 	// toggle uniquement l'inline (PAS de fp.open())
		// 	$('._calendar_inline:visible').not($inlineBox).hide().removeClass('_open');
		//
		// 	$inlineBox.toggle().toggleClass('_open');
		// });

		// $(document).on('click', '.__open_dates', function(e){
		// 	e.preventDefault();
		// 	e.stopPropagation();
		//
		// 	const $wrap  = $(this).closest('._bloc_filter, ._filter_bloc, ._filters, body');
		// 	const input  = $wrap.find('input[name="__filter_date"]').get(0);
		//
		// 	if (!input) return;
		//
		// 	console.log(input);
		// 	// Si flatpickr est déjà initialisé sur cet input
		// 	if (input._flatpickr) {
		// 		console.log("flaty");
		// 		input._flatpickr.open();
		// 	} else {
		// 		// fallback
		// 		input.click();
		// 	}
		// });


		// Les champs date/checkbox de cette modal sont pre-remplis cote
		// serveur avec la recherche ACTIVE (cf. modal_filters.php
		// $_get_date_deb, attributs "checked") - un <button type="reset">
		// natif les remettait donc a cette meme valeur au lieu de les vider.
		// Handler dedie qui vide explicitement chaque champ, cf. retours
		// utilisateur.
		$(document).on("click", "._btn_reset_filters", (e) => {
			e.preventDefault();

			const $modal = $(".__modal_filters");

			$modal.find(".__contain_filters input[type=checkbox]").prop("checked", false);
			// Une page Shore Excursions doit toujours conserver au moins une
			// ville. Le reset revient donc a toutes les villes de la zone.
			$modal.find('.--filter_destination[data-require-one="true"]').prop("checked", true);

			// Reset annule aussi une eventuelle ville en attente (cf.
			// ".__filter_city_pending" plus haut), sinon "Show results"
			// navigerait quand meme vers cette ville malgre le reset.
			$(".__filter_city_pending").prop("hidden", true).removeAttr("data-url");
			$(".__filter_city_search").show();
			$modal.find(".__filter_line").show();
			$modal.find("._bottom_modal").prop("hidden", false);

			// Redeclenche la logique existante du filtre prix (champs Min/Max,
			// cases a cocher associees) plutot que de la dupliquer ici - cf.
			// setupPriceSlider().
			$(document).trigger("price:reset");

			this.refreshActiveFilterChips();
		});


		$(document).on("click", "._btn_close_modal", function () {
			$(".__modal_filters").removeClass("_show");
			$("html,body").removeClass("_overflow");
			$("body").removeClass("__filters_open");
		});

		$(document).on("click", ".__open_filters", function () {
			$(".__modal_filters").addClass("_show");
			$("html,body").addClass("_overflow");
			$("body").addClass("__filters_open");
		});

		$(document).on("click", "._filter_title", function (e) {
			e.stopPropagation();
			const $filterLine = $(this).parent();
			const opensFilter = $filterLine.hasClass("_close");
			$filterLine.toggleClass("_close");

			// Dans la modale, une section qui vient de s'ouvrir se replace en
			// haut de la zone scrollable. Les listes longues restent ainsi
			// lisibles sans obliger l'utilisateur a remonter manuellement et
			// sans faire bouger la page situee derriere le panneau.
			if (opensFilter && $filterLine.closest(".__modal_filters").length) {
				const $scrollContainer = $filterLine.closest(".__contain_filters");

				if ($scrollContainer.length) {
					window.requestAnimationFrame(() => {
						const container = $scrollContainer.get(0);
						const line = $filterLine.get(0);
						const targetTop = container.scrollTop
							+ line.getBoundingClientRect().top
							- container.getBoundingClientRect().top;

						$scrollContainer.stop(true).animate({
							scrollTop: Math.max(0, targetTop)
						}, 280);
					});
				}
			}
		});

		$(document).on("click", ".__modal_filters ._filter_contain li ._title", function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $input = $(this).closest("li").find("input[type=checkbox]").first();
			if ($input.length) {
				$input.trigger("click");
			}
		});


		$(document).on("click", "._filter_bloc > ._header", function (e) {
			e.stopPropagation(); // évite que le click remonte au document

			var __this = $(this).parent();
			__this.toggleClass("_open");

			if (__this.hasClass("_open")) {
				$("._filter_bloc").not(__this).removeClass("_open");
			}
		});

		$(document).on("click", function (e) {
			if (!$(e.target).closest("._filter_bloc").length) {
				$("._filter_bloc").removeClass("_open");
			}
		});

		$(document).on("keydown", function (e) {
			if (e.key === "Escape") {
				$("._filter_bloc._open").removeClass("_open");
			}
		});


		$(document).on("click", ".__block_filter > ._entete", function () {
			$(this).parent().toggleClass("_close");
		});

		// Cases "Cities" regroupees par region (cf. modal_filters.php) : cocher
		// une ville met a jour l'etat de la case region correspondante
		// (cochee seulement si TOUTES ses villes le sont), et cocher/decocher
		// une region repercute sur toutes ses villes d'un coup.
		$(document).on("click", ".--filter_destination", function () {
			const _region = $(this).data("region");
			if ($(this).data("require-one") === true && !$(this).is(":checked")) {
				const $requiredCities = $('.--filter_destination[data-require-one="true"]');
				if ($requiredCities.filter(":checked").length === 0) {
					$(this).prop("checked", true);
				}
			}
			let _checked = true;
			$(".--filter_destination[data-region=" + _region + "]").each(function () {
				if (!$(this).is(":checked")) {
					_checked = false;
				}
			});

			$(".--filter_region[value=" + _region + "]").prop("checked", _checked);
		});

		$(document).on("click", ".--filter_region", function () {
			const _region = $(this).val();
			const _checked = $(this).is(":checked");

			$(".--filter_destination[data-region=" + _region + "]").prop("checked", _checked);
		});

	},

	setupCalendar() {
		const $form = $("#form_result_calendar");
		const $deb = $("#result_date_deb");
		const $end = $("#result_date_end");
		const $input = $("#result_date");

		// Valeurs déjà présentes au chargement
		const initialDeb = $deb.val();
		const initialEnd = $end.val();
		// Prépare defaultDate pour Flatpickr
		let defaultDates = [];

		if (initialDeb) {
			defaultDates.push(initialDeb);
		}

		if (initialEnd) {
			defaultDates.push(initialEnd);
		}



		const fp = flatpickr("#result_date", {
			mode: "range",
			inline: false,
			static: true,
			showMonths: window.innerWidth > 767 ? 2 : 1,
			monthSelectorType: "static",
			dateFormat: "Y-m-d",
			altInput: true,
			altFormat: "M j, Y",
			minDate: "today",
			clickOpens: false,
			closeOnSelect: false,
			animate: false,
			defaultDate: defaultDates.length ? defaultDates : null,
			nextArrow: '<svg class="_ic_lucide"><use xlink:href="#__ic_chevron_lucide"/></svg>',
			prevArrow: '<svg class="_ic_lucide _inverse"><use xlink:href="#__ic_chevron_lucide"/></svg>',

			onReady: function (selectedDates, dateStr, inst) {
				inst.calendarContainer.classList.add("_result_calendar");
				selectedDates = normalizeSelectedDates(selectedDates, inst);

				inst.calendarContainer.querySelectorAll(".cur-year").forEach((el) => {
					el.setAttribute("readonly", true);
				});


				// Évite les doublons si réinit
				if (!inst.calendarContainer.querySelector(".__fp_footer")) {
					const footer = document.createElement("div");
					footer.className = "__fp_footer";

					const clearBtn = document.createElement("button");
					clearBtn.type = "button";
					clearBtn.className = "__fp_clear";
					clearBtn.textContent = "Clear";

					const submitBtn = document.createElement("button");
					submitBtn.type = "submit";
					submitBtn.name = "_btn";
					submitBtn.value = "_dates";
					submitBtn.className = "_ophorus_btn _purple _big";
					submitBtn.setAttribute("form", "form_result_calendar");
					const label = document.createElement("span");
					label.textContent = "Submit dates";
					submitBtn.appendChild(label);
					//submitBtn.disabled = true;
					//submitBtn.disabled = selectedDates.length < 1;

					submitBtn.addEventListener("click", function () {
						const form = document.getElementById("form_result_calendar");
						if (!form) return;

						// si tu veux être sûr que la valeur _btn parte aussi
						let hiddenBtn = form.querySelector('input[name="_btn"].__fp_submit_proxy');

						if (!hiddenBtn) {
							hiddenBtn = document.createElement("input");
							hiddenBtn.type = "hidden";
							hiddenBtn.name = "_btn";
							hiddenBtn.className = "__fp_submit_proxy";
							form.appendChild(hiddenBtn);
						}

						hiddenBtn.value = "_dates";

						form.submit();
					});

					clearBtn.addEventListener("click", function () {
						inst.clear();
						$deb.val("");
						$end.val("");
						//submitBtn.disabled = true;
					});

					footer.appendChild(clearBtn);
					footer.appendChild(submitBtn);
					inst.calendarContainer.appendChild(footer);
				}


				updateRangeFields(selectedDates, inst);
				updateSubmitState(inst, selectedDates);
				updateCalendarState(inst, selectedDates);
			},

			onChange: function (selectedDates, dateStr, inst) {
				selectedDates = normalizeSelectedDates(selectedDates, inst);
				updateRangeFields(selectedDates, inst);
				updateSubmitState(inst, selectedDates);
				updateCalendarState(inst, selectedDates);
			},

			onOpen: function (selectedDates, dateStr, inst) {
				selectedDates = normalizeSelectedDates(selectedDates, inst);
				updateRangeFields(selectedDates, inst);
				updateSubmitState(inst, selectedDates);
				updateCalendarState(inst, selectedDates);
			}
		});

		function normalizeSelectedDates(selectedDates, inst) {
			if (selectedDates.length === 2) {
				const first = inst.formatDate(selectedDates[0], "Y-m-d");
				const second = inst.formatDate(selectedDates[1], "Y-m-d");

				// même jour cliqué 2 fois => on garde une seule date
				if (first === second) {
					inst.setDate([selectedDates[0]], false);
					return [selectedDates[0]];
				}
			}

			return selectedDates;
		}

		function updateCalendarState(inst, selectedDates) {
			if (!inst || !inst.calendarContainer) return;

			inst.calendarContainer.classList.toggle(
				"_single_selected",
				selectedDates.length === 1
			);

			inst.calendarContainer.classList.toggle(
				"_range_selected",
				selectedDates.length === 2
			);
		}

		function updateRangeFields(selectedDates, inst) {
			 const deb = selectedDates[0] ? inst.formatDate(selectedDates[0], "Y-m-d") : "";
			const end = selectedDates[1] ? inst.formatDate(selectedDates[1], "Y-m-d") : "";

			$deb.val(deb);
			$end.val(end);
		}

		function updateSubmitState(inst, selectedDates) {
			// const submitBtn = inst.calendarContainer.querySelector('button[value="_dates"]');
			// if (submitBtn) {
			// 	submitBtn.disabled = selectedDates.length < 2;
			// }
		}

// Ouverture via bouton custom
		$(document).on("click", ".__open_dates, ._btn_dates, [data-open='dates']", function (e) {
			e.preventDefault();
			fp.open();
		});

// Fermeture au clic extérieur
		$(document).on("mousedown", function (e) {
			const $calendar = $(fp.calendarContainer);
			const $triggers = $("._open_dates, ._btn_dates");

			if (
				$calendar.length &&
				!$calendar.is(e.target) &&
				$calendar.has(e.target).length === 0 &&
				!$triggers.is(e.target) &&
				$triggers.has(e.target).length === 0
			) {
				fp.close();
			}
		});

// Responsive : 2 mois desktop / 1 mois mobile
		let calendarResizeTimer = null;

		$(window).on("resize", function () {
			clearTimeout(calendarResizeTimer);

			calendarResizeTimer = setTimeout(function () {
				const months = window.innerWidth > 767 ? 2 : 1;
				if (fp.config.showMonths !== months) {
					fp.set("showMonths", months);
					fp.redraw();
				}
			}, 150);
		});
	},

	old_setupCalendar() {

		const $form = $("#form_result_calendar");
		const $deb = $("#result_date_deb");
		const $end = $("#result_date_end");

		// 1) init flatpickr SUR l’input (même si on le cache)
		const fp = flatpickr("#result_date", {
			mode: "range",
			inline: false,
			static: true,
			showMonths: 2,
			monthSelectorType: "static",
			dateFormat: "M j, Y",
			minDate: "today",
			clickOpens: false,
			closeOnSelect: false,
			nextArrow: '<svg><use xlink:href="#__ic_arrow_fleche"/></svg>',
			prevArrow: '<svg class="_inverse"><use xlink:href="#__ic_arrow_fleche"/></svg>',

			onReady: function (_, __, inst) {
				inst.calendarContainer.classList.add("_result_calendar");

				// (optionnel) bouton submit dans le calendar, rattaché au form
				const footer = document.createElement("div");
				footer.className = "__fp_footer";

				const btn = document.createElement("button");
				btn.type = "submit";
				btn.name = "_btn";
				btn.value = "_dates";
				btn.className = "_ophorus_btn purple";
				btn.textContent = "Submit";
				btn.setAttribute("form", "form_result_calendar");

				footer.appendChild(btn);
				inst.calendarContainer.appendChild(footer);
			},

			onChange: function (selectedDates) {
				// Sync hidden inputs (si tu les utilises)
				const deb = selectedDates[0] ? selectedDates[0].toISOString().slice(0, 10) : "";
				const end = selectedDates[1] ? selectedDates[1].toISOString().slice(0, 10) : "";
				$("#result_date_deb").val(deb);
				$("#result_date_end").val(end);
			}
		});

		// 2) cacher l’input et ouvrir via le bouton Dates
		$("#result_date").addClass("_hidden_fp_input"); // ou .hide() si tu veux

		$(document).on("click", ".__open_dates, ._btn_dates, [data-open='dates']", function (e) {
			e.preventDefault();
			e.stopPropagation();
			fp.open(); // ✅ ouvre flatpickr via le bouton
		});

		// 3) click outside => close (optionnel)
		$(document).on("click", function (e) {
			const inside =
				$(e.target).closest(".flatpickr-calendar").length ||
				$(e.target).closest(".__open_dates, ._btn_dates, [data-open='dates']").length;
			if (!inside && fp.isOpen) fp.close();
		});

		// $('.__open_dates').each(function () {
		//
		// 	const $btnOpen   = $(this);
		// 	const $root      = $btnOpen.parent();
		// 	const $input     = $root.find('input[name="__filter_date"]').first();
		// 	const $hidden    = $root.find('input.__search_calendar').first();
		// 	const $inlineBox = $root.find('._calendar_inline').first();
		//
		// 	if (!$input.length || !$inlineBox.length) return;
		//
		// 	// Evite double init + destroy si déjà flatpickr
		// 	if ($input[0]._flatpickr) $input[0]._flatpickr.destroy();
		//
		// 	// Container dédié pour le calendrier (évite qu'il s'injecte n'importe où)
		// 	let $calHost = $inlineBox.find('._fp_host');
		// 	if (!$calHost.length) {
		// 		$calHost = $('<div class="_fp_host"></div>');
		// 		$inlineBox.prepend($calHost);
		// 	}
		//
		// 	const fp = flatpickr($input[0], {
		// 		inline: true,            // ✅ vrai inline
		// 		appendTo: $calHost[0],   // ✅ injecté dans ton bloc
		// 		mode: 'range',           // ✅ range
		// 		dateFormat: 'Y-m-d',
		// 		// IMPORTANT: pour tester le range en 2026, retire minDate
		// 		// minDate: 'today',
		// 		disableMobile: true,
		// 		clickOpens: false,
		// 		closeOnSelect: false,
		// 		locale: { firstDayOfWeek: 1 },
		//
		// 		onChange: function(selectedDates, dateStr) {
		// 			// Remplissage garanti
		// 			$input.val(dateStr);
		// 			if ($hidden.length) $hidden.val(dateStr);
		//
		// 			// Option : si tu veux fermer quand range complet
		// 			// if (selectedDates.length === 2) $inlineBox.removeClass('_open').hide();
		// 		}
		// 	});
		//
		// 	$input.data('fp', fp);
		//
		// 	// fermé par défaut
		// 	$inlineBox.hide().removeClass('_open');
		//
		// 	// Ouvrir/fermer via bouton Dates (inlineBox)
		// 	$btnOpen.off('click.fp').on('click.fp', function(e){
		// 		e.preventDefault();
		// 		e.stopPropagation();
		//
		// 		// ferme les autres calendriers
		// 		$('._calendar_inline:visible').not($inlineBox).hide().removeClass('_open');
		//
		// 		$inlineBox.toggle().toggleClass('_open');
		// 	});
		//
		// 	// Close
		// 	$root.off('click.fpclose').on('click.fpclose', '.__close_calendar', function(e){
		// 		e.preventDefault();
		// 		e.stopPropagation();
		// 		$inlineBox.hide().removeClass('_open');
		// 	});
		//
		// 	// Clear
		// 	$root.off('click.fpclear').on('click.fpclear', '._btn_clear, ._clear_calendar', function(e){
		// 		e.preventDefault();
		// 		e.stopPropagation();
		// 		fp.clear();
		// 		$input.val('');
		// 		if ($hidden.length) $hidden.val('');
		// 		$inlineBox.hide().removeClass('_open');
		// 	});
		//
		// 	// Today / Tomorrow
		// 	$root.off('click.fptoday').on('click.fptoday', '._choose_date', function(e){
		// 		e.preventDefault();
		// 		e.stopPropagation();
		// 		const type = $(this).data('date');
		// 		const d = new Date();
		// 		if (type === 'tomorrow') d.setDate(d.getDate() + 1);
		// 		fp.setDate(d, true);
		// 	});
		//
		// 	// +days (étend le range)
		// 	$root.off('click.fpplus').on('click.fpplus', '._btn_plus', function(e){
		// 		e.preventDefault();
		// 		e.stopPropagation();
		//
		// 		const plus = parseInt($(this).data('plus'), 10) || 0;
		// 		const dates = fp.selectedDates || [];
		// 		if (!dates.length) return;
		//
		// 		const start = dates[0];
		// 		const end   = dates[1] || dates[0];
		// 		const newEnd = new Date(end);
		// 		newEnd.setDate(newEnd.getDate() + plus);
		//
		// 		fp.setDate([start, newEnd], true);
		// 	});
		//
		// 	// Click outside => ferme
		// 	$(document).off('click.fpclickout').on('click.fpclickout', function(e){
		// 		const inside = $(e.target).closest($inlineBox).length > 0 || $(e.target).closest($btnOpen).length > 0;
		// 		if (!inside) $inlineBox.hide().removeClass('_open');
		// 	});
		//
		// });

	},

	__setupCalendar() {
		const _deb = $("input[name=filter_date_deb]").val();
		const _end = $("input[name=filter_date_end]").val();
		const defaultDate = _deb && _end ? [_deb, _end] : _deb ? _deb : "today";

		const fp = flatpickr($input[0], {
			mode: "range",
			dateFormat: "Y-m-d",
			// pour debug range : commente minDate si besoin
			minDate: new Date(), // plus fiable que 'today'
			disableMobile: true,
			clickOpens: false,

			appendTo: $popover[0],

			// optionnel mais souvent mieux en range
			closeOnSelect: false,

			locale: {firstDayOfWeek: 1},

			onOpen: function () {
				positionPopoverUnderButton($popover[0], $btnOpen[0]);
				$popover.removeClass('_hide');
			},

			onClose: function () {
				$popover.addClass('_hide');
			},

			// IMPORTANT : onChange = moment fiable où selectedDates est à jour
			onChange: function (selectedDates, dateStr) {

				// Flatpickr remplit déjà l'input, mais on sécurise:
				$input.val(dateStr);

				if ($hidden.length) $hidden.val(dateStr);

				// Si tu veux auto-close quand range complet:
				// if (selectedDates.length === 2) fp.close();
			},

			// Optionnel (si tu veux maintenir le hidden même pendant la sélection)
			onValueUpdate: function (selectedDates, dateStr) {
				if ($hidden.length) $hidden.val(dateStr);
			}
		});
	},

	setupLoadMore() {
		$(document).on("click", ".--load_more_btn", function () {
			const _type = $("input[name=produit_show]").val();
			$.post(`${_SITE_URL}more-results`, {type_grille: _type}, (response) => {
				const data = JSON.parse(response);
				if (data.nb_inview === data.nb_total) {
					$(".__load_more").hide();
				}
				$(".__results_products").append(data.products);
				categories.fit();
				// Reapplique le filtre "Search a tour" en cours (s'il y en a
				// un) aux cartes qui viennent d'etre ajoutees.
				applyProductSearchFilter();
			});
		});
	},

	setupProductSearch() {
		$(document).on("input", "#__results_search_input", applyProductSearchFilter);

		$(document).on("click", ".__clear_product_search", () => {
			$("#__results_search_input").val("").trigger("input").trigger("focus");
		});

		$(document).on("click", ".__reset_results_filters", () => {
			const $modal = $(".__modal_filters");
			$modal.find("._btn_reset_filters").trigger("click");
			$modal.find('button[name="_btn"][value="_new_search"]').trigger("click");
		});
	},

	// Barre mobile "Filtrer/Rechercher" collee sous le header au scroll -
	// meme mecanique que blog.js stickyFilterBar() (sentinelle invisible
	// juste au-dessus, IntersectionObserver qui bascule ".__mobile_filter_bar"
	// en "._stuck" des qu'elle sort du viewport).
	stickyMobileFilterBar() {
		const sentinel = document.querySelector('.__mobile_filter_bar_sentinel');
		const bar = document.querySelector('.__mobile_filter_bar');

		if (!sentinel || !bar || !('IntersectionObserver' in window)) {
			return;
		}

		const observer = new IntersectionObserver(([entry]) => {
			bar.classList.toggle('_stuck', !entry.isIntersecting);
		}, {threshold: 0});

		observer.observe(sentinel);
	},

	// Barre desktop "Filtrer/Dates/Rechercher" (".__result_stick_filters") :
	// filet ("_stuck") affiche uniquement une fois reellement collee, cf.
	// stickyMobileFilterBar ci-dessus. Le decrochage une fois la grille de
	// produits depassee n'a plus besoin de JS : ".__results_sticky_range"
	// (wrapper commun a la barre et a la grille, cf. results_contain.php)
	// borne deja nativement la zone de sticky en CSS pur - l'ancienne
	// approche (bascule position:sticky/static via une 2e sentinelle)
	// pouvait perdre l'etat sticky apres un premier decrochage, cf. retours
	// utilisateur ("ne stick plus du tout").
	stickyDesktopFilterBar() {
		const bar = document.querySelector('.__result_stick_filters');
		const startSentinel = document.querySelector('.__result_stick_filters_sentinel');

		if (!bar || !startSentinel || !('IntersectionObserver' in window)) {
			return;
		}

		const startObserver = new IntersectionObserver(([entry]) => {
			bar.classList.toggle('_stuck', !entry.isIntersecting);
		}, {threshold: 0});
		startObserver.observe(startSentinel);
	}
};

export default results;
